import { render, staticRenderFns } from "./termsCom.vue?vue&type=template&id=0271aba4&"
import script from "./termsCom.vue?vue&type=script&lang=js&"
export * from "./termsCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports